import React from 'react';

import Data from './Data';

const AZListSidebar = (props) => {
  return <Data {...props} />;
};

export default AZListSidebar;
